import AppDispatcher from '../dispatcher/Dispatcher';

export default {
    viewChange(view) {
        let action = {
            actionType: "VIEW_CHANGE",
            view: view
        };
        AppDispatcher.dispatch(action);
    },
    collapseWidget(data) {
        let action = {
            actionType: "COLLAPSE_WIDGET",
            widget: data.widget,
            collapsed: data.collapsed
        };
        AppDispatcher.dispatch(action);
    },
    showModal(data) {
        let action = {
            actionType: "SHOW_MODAL",
            modal: data.modal,
            show: data.show,
        };
        AppDispatcher.dispatch(action);
    },
    layersChange(data) {
        let action = {
            actionType: "LAYERS_CHANGE",
            backgroundLayer: data.backgroundLayer,
            extraBackgroundLayers: data.extraBackgroundLayers,
            customLayers: data.customLayers
        };
        AppDispatcher.dispatch(action);
    }
};